import type { UUID } from "../../../utils";

export const BASE_URL = "/configuration/users";

export const PAGE_URLS = {
  create: `${BASE_URL}/create`,
  list: BASE_URL,
  getLinkToDetails: (id: UUID) => `${BASE_URL}/${id}`,
  getLinkToEdit: (id: UUID) => `${BASE_URL}/${id}/edit`,
} as const;
